var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9608 5.30624C13.9191 5.21524 13.8489 5.1376 13.7591 5.08311C13.6693 5.02861 13.5639 4.99969 13.4561 5H2.54386C2.43614 4.99969 2.33073 5.02861 2.24092 5.08311C2.1511 5.1376 2.0809 5.21524 2.03916 5.30624C1.99985 5.39859 1.98988 5.49925 2.0104 5.59658C2.03092 5.6939 2.08109 5.78392 2.15511 5.85621L7.61125 10.8559C7.71554 10.9483 7.85493 11 8 11C8.14507 11 8.28446 10.9483 8.38875 10.8559L13.8449 5.85621C13.9189 5.78392 13.9691 5.6939 13.9896 5.59658C14.0101 5.49925 14.0001 5.39859 13.9608 5.30624Z",
    fill: "white",
    fillOpacity: 0.66
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/CaretDown.ae54701487d265d31258a499d9c26320.svg";
export { ForwardRef as ReactComponent };